import React, { type FunctionComponent, type ReactNode } from 'react'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  label: string
  searchTerm: string
  disabled: boolean
  onSubmit: () => void
  onChange: (term: string) => void
  clearResults: () => void
  children?: ReactNode
}

export const SearchForm: FunctionComponent<Props> = ({
  label,
  searchTerm,
  disabled,
  onSubmit,
  onChange,
  clearResults,
  children
}) => {
  const disableButton = disabled || !searchTerm

  const _onChange = (value: string) => {
    if (value === '') {
      clearResults()
    }

    onChange(value)
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <label className="block mb-sm" htmlFor="searchField">
        {label}
      </label>

      <div className="flex justify-between">
        <input
          id="searchField"
          type="search"
          className="mr-md border border-gray-300 rounded px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent"
          value={searchTerm}
          disabled={disabled}
          onChange={({ target: { value } }) => _onChange(value)}
          autoComplete="off"
        />
        <Button type="submit" disabled={disableButton}>
          Search
        </Button>
      </div>

      {children}
    </form>
  )
}
